<template>

    <div class="refresh-settings">
      <el-input
        v-model.number="refreshRate"
        placeholder="请输入刷新间隔时间（秒）"
        type="number"
        @change="updateRefreshRate"
      />
      <el-button @click="updateRefreshRate">更新刷新时间</el-button>
    </div>
    <div class="news-list" >
      <el-card v-for="news in newsList" :key="news.id" shadow="hover" class="news-item" @click="openInIframe(news.shareurl)">
        <div class="news-header">
          <h3>{{ news.title || news.brief }}</h3>
        </div>
        <div class="news-content">
          <p>{{ news.brief }}</p>
          <div class="news-footer">
            <span>阅读数: {{ news.reading_num }}</span>
          </div>
        </div>

        <div class="news-date">

        </div>
      </el-card>
    </div>
 <!-- 使用组件 -->
    <MobileIframeViewer
      v-if="showIframe"
      :show-iframe="showIframe"
      :iframe-src="iframeSrc"
      @close="closeIframe"
    />
</template>

<script>
import axios from 'axios';
import MobileIframeViewer from '@/components/MobileIframeViewer.vue';
export default {
 components: {
    MobileIframeViewer
  },
  name: 'ClsPage',
  data() {
    return {
      newsList: [],
      refreshInterval: null, // 定时器
      refreshRate: 60, // 默认刷新间隔时间，单位为秒（例如：60秒 = 1分钟）
      showIframe: false,
      iframeSrc: '',
      loading: false
    };
  },
  created() {
    this.fetchNews();
    this.startRefresh();
  },
  beforeUnmount() {
    this.stopRefresh();
  },
  methods: {
    async fetchNews() {
      try {
        const response = await axios.get('/api/cls',{

        });
        this.newsList = response.data.data.roll_data;
      } catch (error) {
        console.error('Error fetching news:', error);
      }
    },
    startRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }
      this.refreshInterval = setInterval(() => {
        this.fetchNews();
      }, this.refreshRate * 1000); // 将秒转换为毫秒
    },
    stopRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    updateRefreshRate() {
      this.stopRefresh();
      this.startRefresh();
    },
    openInIframe(url) {
      if (url) {
        this.iframeSrc = url;
        this.showIframe = true;
      }
    },
    closeIframe() {
      this.showIframe = false;
      this.iframeSrc = '';
    },
  },
};
</script>

<style scoped>
.news-list-container {
  padding: 20px;
}

.refresh-settings {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.refresh-settings .el-input {
  margin-right: 10px;
  width: 200px;
}

.news-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.news-item {
  width: calc(100% - 40px);
  margin-bottom: 20px;
  transition: transform 0.2s;

  @media (min-width: 768px) {
    width: calc(50% - 40px);
  }

  @media (min-width: 1024px) {
    width: calc(33.33% - 40px);
  }

  &:hover {
    transform: translateY(-10px);
  }
}

.news-header {
  margin-bottom: 10px;
}

.news-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.news-footer {
  margin-top: 10px;
  font-size: 14px;
  color: #999;
}
</style>
